/**
* RacingRegion defines model for racingRegion information
*
* @typedef RacingRegionInfo
* @type {Object}
* @property {id} Id identifier
* @property {name} Name identifier
* @property {hasEvents} Show if this regions has events
*/

export class RacingRegionInfo
{
    id : number
    name : string
    hasEvents : boolean

    constructor(source: RacingRegionInfo)
    {
        this.id = source.id
        this.name = source.name
        this.hasEvents =  source.hasEvents
    }
}
